import { titleToSlug } from "./shared/stringUtils";

export const buildPropertyUrl = (
  title: string,
  params?: URLSearchParams,
): string => {
  const slug = titleToSlug(title);
  const baseUrl = `/propiedades/${slug}`;
  return params && params.toString()
    ? `${baseUrl}?${params.toString()}`
    : baseUrl;
};

export const copyUrlToClipboard = async (url?: string): Promise<boolean> => {
  try {
    const targetUrl = url || window.location.href;
    await navigator.clipboard.writeText(targetUrl);
    return true;
  } catch (error) {
    console.error("Error copying URL to clipboard:", error);
    return false;
  }
};
